import script from "./score-item-show-more-button.vue?vue&type=script&lang=ts&setup=true"
export * from "./score-item-show-more-button.vue?vue&type=script&lang=ts&setup=true"

import "./score-item-show-more-button.vue?vue&type=style&index=0&id=3a9340df&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a9340df"]])

export default __exports__